export default function FeaturesSection() {
  const features = [
    {
      icon: 'ri-flashlight-line',
      title: '秒开无卡顿',
      desc: '极速加载，即点即播，告别缓冲等待',
    },
    {
      icon: 'ri-4k-line',
      title: '高清画质',
      desc: '全高清影视资源，沉浸式观影体验',
    },
    {
      icon: 'ri-refresh-line',
      title: '实时更新',
      desc: '最新电影电视剧第一时间同步上线',
    },
    {
      icon: 'ri-shield-check-line',
      title: '免费安全',
      desc: '完全免费，无需注册，安全可靠',
    },
  ];

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {features.map((feat) => (
            <div
              key={feat.title}
              className="flex flex-col items-center text-center p-5 md:p-6 rounded-lg bg-background-50 border border-background-200/70"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-accent-100/80 mb-3 md:mb-4">
                <i className={`${feat.icon} text-xl md:text-2xl text-accent-700`}></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-950">{feat.title}</h3>
              <p className="text-xs text-foreground-500 mt-1.5 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}